var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLiimaColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.177,
    height: 38.462,
    viewBox: "0 0 104.177 38.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.201,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c72ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#c057ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0749b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M75.164-701.111V-731.86h4.114V-700.7q0,3.548,3.6,3.754v3.548Q75.164-693.4,75.164-701.111Zm13.369-24.424v-4.833h4.525v4.833Zm.206,31.726v-26.739h4.114v26.739Zm12.135-31.726v-4.833H105.4v4.833Zm.206,31.726v-26.739h4.114v26.739Zm12.341,0v-26.739h30.338q7.713,0,7.713,7.713v19.026h-4.114v-19.54q0-3.6-3.6-3.6H134.5v23.139h-4.114v-23.139H117.534v23.139Zm52.4,0q-7.764,0-7.764-7.765t7.764-7.764h9.41v-4.011q0-3.6-3.6-3.6h-11V-719l2.057-1.543h8.947q7.713,0,7.713,7.713v19.026Zm-3.651-7.2q0,3.6,3.6,3.6h9.461V-706h-9.461q-3.6,0-3.6,3.6Z",
    transform: "translate(-75.164 731.86)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiimaColor);
export default __webpack_public_path__ + "static/media/liima-color.18165b1f833cd8399742253aebd3a803.svg";
export { ForwardRef as ReactComponent };